import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { RadioField } from '@openx/components-core/lib/RadioField/RadioField.tsx';
import { type ChangeEvent, useCallback } from 'react';
import type { AudienceListType } from '../../../../../../../../modules/audiences/AudienceForm/types.ts';
import { audienceLocation, audienceLocationOptions, type SelectedLocationSegment } from '../../../constants.ts';
import { LocationContent } from './LocationContent.tsx';
import type { SegmentSetters, Segments } from './LocationSection.tsx';

export type LocationExpandedProps = {
  isEdit: boolean;
  listType: AudienceListType;
  selectedLocationSegment: SelectedLocationSegment;
  setSelectedLocationSegment: (segment: SelectedLocationSegment) => void;
  segmentSetters: SegmentSetters;
  segments: Segments;
};

export const LocationExpanded = ({
  isEdit,
  listType,
  selectedLocationSegment,
  setSelectedLocationSegment,
  segmentSetters,
  segments,
}: LocationExpandedProps) => {
  const handleSelectedLocationSegmentChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const newSegment = e.target.value as SelectedLocationSegment;
      const isNewSegment = selectedLocationSegment !== audienceLocation.Any && selectedLocationSegment !== newSegment;

      if (isNewSegment) {
        const setter = segmentSetters[selectedLocationSegment];

        setter([]);
      }

      setSelectedLocationSegment(newSegment);
    },
    [selectedLocationSegment, segmentSetters, setSelectedLocationSegment]
  );

  const selectedSegmentValue = audienceLocationOptions.find(option => option.value === selectedLocationSegment);

  return (
    <>
      {isEdit ? (
        <RadioField
          value={selectedLocationSegment}
          onChange={handleSelectedLocationSegmentChange}
          fullWidth
          options={audienceLocationOptions}
          sx={{ flexDirection: 'row' }}
        />
      ) : (
        <Stack>
          <Typography variant={'h3'}>Type</Typography>
          <Typography>{selectedSegmentValue?.label}</Typography>
        </Stack>
      )}

      <LocationContent
        isEdit={isEdit}
        listType={listType}
        selectedLocationSegment={selectedLocationSegment}
        segments={segments}
        segmentSetters={segmentSetters}
      />
    </>
  );
};
